import { RowCountryDto } from "@/dtos";
import { Country } from "@/entities";

export const formatRowCountryDto = (countries: Country[]) => {
    return countries.map(x => {
        const row: RowCountryDto = {
            ...x,
            active: (x.is_active) ? 'Activo' : 'Inactivo'
        }
        return row;
    });
}